import { render, staticRenderFns } from "./TrainingPlanItemDescription.vue?vue&type=template&id=84e3fd54&scoped=true&"
import script from "./TrainingPlanItemDescription.vue?vue&type=script&lang=ts&"
export * from "./TrainingPlanItemDescription.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingPlanItemDescription.vue?vue&type=style&index=0&id=84e3fd54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e3fd54",
  null
  
)

export default component.exports